import { SortOrder } from 'antd/es/table/interface';

type SortInfo = { field: string; order: string };

const sortOrderMap: Record<string, SortOrder | undefined> = {
  ASC: 'ascend',
  DESC: 'descend',
};

export function getTableSortOrder(sortInfo: SortInfo[], field: string): SortOrder | undefined {
  const entry = sortInfo.find((info) => info.field === field);
  return entry ? sortOrderMap[entry.order] : undefined;
}
